/**
 * A tradução do vocabulário da Meta para o rótulo que aparece no cartão.
 *
 * Estava dentro de `useChannelProfiles`, junto do hook. Saiu de lá porque é
 * função pura e o hook arrasta `@/utils/api`, que lê `import.meta.env` — um
 * global do Vite que não existe fora do navegador. Quem só precisa do rótulo
 * não deveria precisar da camada de rede junto.
 *
 * `useChannelProfiles` reexporta tudo daqui: nenhum consumidor mudou.
 */

/**
 * A geometria de um selo de canal. Vive aqui, e não dentro do cartão, porque o
 * `AppConnectChannelCard` monta os próprios selos (ativo/inativo/plano) e uma
 * segunda definição divergiria da primeira em silêncio — o mesmo motivo pelo
 * qual o cartão saiu da tela de Integrações.
 */
export const BADGE_BASE =
  "inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium border";

export function getStatusConfig(status) {
  const map = {
    CONNECTED: { label: "Conectado", color: "green", dotClass: "bg-green-400" },
    FLAGGED: {
      label: "Sinalizado",
      color: "yellow",
      dotClass: "bg-yellow-400",
    },
    RESTRICTED: { label: "Restrito", color: "red", dotClass: "bg-red-400" },
    DISCONNECTED: {
      label: "Desconectado",
      color: "gray",
      dotClass: "bg-foreground-muted",
    },
    PENDING: { label: "Pendente", color: "yellow", dotClass: "bg-yellow-400" },
    BANNED: { label: "Banido", color: "red", dotClass: "bg-red-500" },
  };
  return (
    map[status] || {
      label: status || "Desconhecido",
      color: "gray",
      dotClass: "bg-foreground-muted",
    }
  );
}

export function getQualityConfig(qualityRating) {
  const map = {
    GREEN: { label: "Alta", color: "green", dotClass: "bg-green-400" },
    YELLOW: { label: "Média", color: "yellow", dotClass: "bg-yellow-400" },
    RED: { label: "Baixa", color: "red", dotClass: "bg-red-400" },
    NA: { label: "N/A", color: "gray", dotClass: "bg-foreground-muted" },
    UNKNOWN: { label: "N/A", color: "gray", dotClass: "bg-foreground-muted" },
  };
  return (
    map[qualityRating] || {
      label: "N/A",
      color: "gray",
      dotClass: "bg-foreground-muted",
    }
  );
}

export function getStatusBadgeClasses(color) {
  const map = {
    green:
      "bg-green-500/15 dark:bg-green-500/10 text-green-700 dark:text-green-400 border-green-500/30 dark:border-green-500/20",
    yellow:
      "bg-yellow-500/15 dark:bg-yellow-500/10 text-yellow-700 dark:text-yellow-400 border-yellow-500/30 dark:border-yellow-500/20",
    red: "bg-red-500/15 dark:bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/30 dark:border-red-500/20",
    gray: "bg-foreground-muted/10 text-foreground-muted border-border-strong/20",
  };
  return map[color] || map.gray;
}
